import { create } from 'zustand';

interface AudioStore {
  currentlyPlayingArticleId: string | null;
  isAudioPlaying: boolean;
  setCurrentlyPlayingArticle: (articleId: string | null) => void;
  setIsAudioPlaying: (isPlaying: boolean) => void;
}

export const useAudioStore = create<AudioStore>((set) => ({
  currentlyPlayingArticleId: null,
  isAudioPlaying: false,
  setCurrentlyPlayingArticle: (articleId) => set({ currentlyPlayingArticleId: articleId }),
  setIsAudioPlaying: (isPlaying) => set({ isAudioPlaying: isPlaying }),
}));
